export default __webpack_public_path__ + "static/media/logo-md-1024w.68e86fc9.avif";